import React from 'react';

import Table from 'react-bootstrap/Table';

import CompanyRow from './CompanyRow';

class CompanyTable extends React.Component {
    render() {
	const companies = this.props.companies;
	
	return (
	    <Table striped bordered hover responsive size="sm">
		<thead>
		    <tr>
			<th>F&ouml;retag</th>
			<th>Gatudress</th>
			<th>Ort</th>
			<th>Tel</th>
			<th>Hemsida</th>
			<th>Kategori</th>
		    </tr>
		</thead>
		<tbody>
		    {companies.map(company => (
			<CompanyRow company={company} key={company.id} />
		    ))}
		</tbody>
	    </Table>
	);
    }
}

export default CompanyTable;
